module.exports = __webpack_public_path__ + "img/noDate.767ba683.png";